module.exports = __webpack_public_path__ + "img/atlas-logo.2b55c189.png";